import { GetterTree } from "vuex";
import { State } from "./state";

import { RootState } from "@/store";
import { Variable } from "@/models/VorlageModels";


export type Getters = {
  variablen(state: State): Array<Variable>,
}

export const getters: GetterTree<State, RootState> & Getters = {
  variablen(state) {
    return state.variablen;
  },
}
